import { Injectable } from '@angular/core';
import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root'
})
export class ScansService {
  url: string = 'scans';

  constructor(private httpClient: HttpClientService) {}

  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }
  queueStatus(): Promise<any> {
    return this.httpClient.get(`${this.url}/queue_status.json`, {});
  }
  getDocTypes(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}/document_types.json`, params);
  }
  availableAuthors(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}/scan_authors_available.json`, params);
  }
  authors(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}/scan_authors.json`, params);
  }
  delete(params: any = {}): Promise<any> {
    return this.httpClient.delete(`${this.url}/${params.id}.json`);
  }
  bulkDelete(params: any = {}): Promise<any> {
    return this.httpClient.delete(`${this.url}/bulk_destroy.json`, params);
  }
  destroyAuthor(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}/destroy_author.json`, params);
  }
  destroyMatter(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}/destroy_matter.json`, params);
  }
  edit(id: number): Promise<any> {
    return this.httpClient.get(`${this.url}/${id}/edit.json`, { })
  }
  release(params: any= {}): Promise<any> {
    return this.httpClient.post(`${this.url}/release.json`, params)
  }
  accept(params: any= {}): Promise<any> {
    return this.httpClient.post(`${this.url}/accept.json`, params)
  }
  getScanMatters(params: any): Promise<any> {
    return this.httpClient.post(`${this.url}/scan_matters.json`, params)
  }
  setScanMatter(params: any): Promise<any> {
    return this.httpClient.post(`${this.url}/scan_matters.json`, params)
  }
  save(params: any): Promise<any> {
    if(params.id)
      return this.httpClient.put(`${this.url}/${params.id}.json`, params);
    else
      return this.httpClient.post(`${this.url}.json`, params);
  }
}
